
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitmentCountries",
      function () {
        return require("private-next-pages/recruitmentCountries/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruitmentCountries"])
      });
    }
  